module.exports = __webpack_public_path__ + "img/caution.010a9b9f.svg";